import { Box, Skeleton } from '@mui/material';

export const BlogPlaceholder = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          paddingBottom: '75%',
          overflow: 'hidden',
        }}
      >
        <Skeleton
          variant='rectangular'
          width='100%'
          height='100%'
          sx={{ position: 'absolute', top: 0, left: 0 }}
        />
      </Box>

      <Skeleton
        variant='rectangular'
        sx={{ width: '80%', height: '18px', mt: 1 }}
      />

      <Skeleton
        variant='rectangular'
        sx={{ width: '60%', height: '16px', mt: 1 }}
      />
    </Box>
  );
};
